module.exports = __webpack_public_path__ + "roboto-lightitalic-webfont.40e8ab1e0cb5fb30e148.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-lightitalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-lightitalic-webfont.woff2
// module chunks = styles